import { render } from "./EventCard.vue?vue&type=template&id=1239e2bc&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=1239e2bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1239e2bc"

export default script